import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { useLanguage } from "../../contexts/LanguageContext";
import { privacy } from "../../utils/translations";
import useIsMobilei from "../../hooks/isMobile"; 
import "./privacy.css";

export default function Privacy() {
  const { isMobilei } = useIsMobilei(); 
  const { language } = useLanguage();
  const isRtl = language === "ar";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={`privacy-mainDiv ${language === "ar" ? "arab" : ""}`}>
      <motion.div 
        style={{ marginTop: isMobilei ? "0" : "40px" }}
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5 }}
        className={`privacy-container ${isRtl ? "rtl" : ""}`}>
        
        {[
          { header: privacy[language].privacyPolicy, texts: [
          ]},
          { header: privacy[language].appIntroduction, texts: [
            privacy[language].appIntroduction1,
            privacy[language].appIntroduction2,
            privacy[language].appIntroduction3,
            privacy[language].appIntroduction4
          ]},
          { header: privacy[language].responsibleEntity, texts: [
            privacy[language].responsibleEntity1,
            privacy[language].responsibleEntity2,
            privacy[language].responsibleEntity3,
            privacy[language].responsibleEntity4
          ]},
          { header: privacy[language].targetAudience, texts: [
            privacy[language].targetAudience1,
          ]},
          { header: privacy[language].appFunctionality, texts: [
            privacy[language].appFunctionality1,
            privacy[language].appFunctionality2,
            privacy[language].appFunctionality3
          ]},
          { header: privacy[language].dataProtection, texts: [
            privacy[language].dataProtection1,
            privacy[language].dataProtection2,
            privacy[language].dataProtection3,
            privacy[language].dataProtection4,
            privacy[language].dataProtection5,
            privacy[language].dataProtection6,
          ]},
          { header: privacy[language].userResponsibilities, texts: [
            privacy[language].userResponsibilities1,
            privacy[language].userResponsibilities2,
            privacy[language].userResponsibilities3
          ]},
          { header: privacy[language].informationWeCollect, texts: [
            privacy[language].informationWeCollect1,
            privacy[language].informationWeCollect2,
            privacy[language].informationWeCollect3
          ]},
          { header: privacy[language].rightOfTheOwner, texts: [] },
          { header: privacy[language].rightOfTheOwnerSub, texts: [
            privacy[language].rightOfTheOwnerSub1,
            privacy[language].rightOfTheOwnerSub2,
          ]},
          { header: privacy[language].duties, texts: [
            privacy[language].duties1,
            privacy[language].duties2,
            privacy[language].duties3,
          ]},
          { header: privacy[language].violationMeasures, texts: [
            privacy[language].violationMeasures1
          ]},
          { header: privacy[language].privacyPolicyUpdate, texts: [
            privacy[language].privacyPolicyUpdate1
          ]},
          { header: privacy[language].UseOfYourInformation, texts: [
            privacy[language].UseOfYourInformation1
          ]},
          { header: privacy[language].reasonsForUsingYourInformation, texts: [
            privacy[language].reasonsForUsingYourInformation1,
            privacy[language].reasonsForUsingYourInformation2,
            privacy[language].reasonsForUsingYourInformation3,
            privacy[language].reasonsForUsingYourInformation4,
            privacy[language].reasonsForUsingYourInformation5,
            privacy[language].reasonsForUsingYourInformation6,
            privacy[language].reasonsForUsingYourInformation7,
            privacy[language].reasonsForUsingYourInformation8,
            privacy[language].reasonsForUsingYourInformation9
          ]},
          { header: privacy[language].retentionOfYourInformation, texts: [
            privacy[language].retentionOfYourInformation1,
            privacy[language].retentionOfYourInformation2,
            privacy[language].retentionOfYourInformation3,
            privacy[language].retentionOfYourInformation4,
            privacy[language].retentionOfYourInformation5
          ]},
          { header: privacy[language].disclosureOfYourInformation, texts: [
            privacy[language].disclosureOfYourInformation1,
            privacy[language].disclosureOfYourInformation2,
            privacy[language].disclosureOfYourInformation3,
            privacy[language].disclosureOfYourInformation4,
            privacy[language].disclosureOfYourInformation5,
            privacy[language].disclosureOfYourInformation6,
            privacy[language].disclosureOfYourInformation7,
            privacy[language].disclosureOfYourInformation8,
            privacy[language].disclosureOfYourInformation9,
            privacy[language].disclosureOfYourInformation10,
          ]},
          { header: privacy[language].content, texts: [
            privacy[language].content1,
          ]},
          { header: privacy[language].compensation, texts: [
            privacy[language].compensation1,
          ]},
          { header: privacy[language].limitationOfLiability, texts: [
            privacy[language].limitationOfLiability1,
          ]},
          { header: privacy[language].waiverOfWarranty, texts: [
            privacy[language].waiverOfWarranty1,
          ]},
          { header: privacy[language].ThirdPartyDisclaimer, texts: [
            privacy[language].ThirdPartyDisclaimer1,
          ]},
        ]
        .filter(section => section.header?.trim())
        .map((section, index) => (
          <motion.div 
            key={index} 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="terms-section"
          >
            <motion.p 
              className="terms-sectionHeader" 
              initial={{ scale: 0.8 }} 
              animate={{ scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              {section.header}
            </motion.p>
            {section.texts
              .filter(text => text?.trim()) // تجاهل النصوص الفارغة
              .map((text, i) => (
                <motion.p 
                  key={i} 
                  className="terms-sectionText" 
                  initial={{ opacity: 0, x: -10 }} 
                  animate={{ opacity: 1, x: 0 }} 
                  transition={{ delay: index * 0.2 + i * 0.1 }}
                >
                  {text}
                </motion.p>
              ))}
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
}
